package com.fireavert.devices.data_models.response

import com.fireavert.devices.data_models.data_model.PowerStatus
import kotlinx.serialization.Serializable

@Serializable
data class DevicePowerOnResponse(
    val devicesToPower: Map<Int, PowerStatus>
)
